// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wQMr","importantInfo":"styles_importantInfo__2d31V"};